import React, { lazy } from "react";
import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";
import Technologies from "./Technologies";
import CaseStudy from "./case_study";

const OurWorkDetails = () => {
return  <>
            
            
        </>
}

export default OurWorkDetails;